module.exports = __webpack_public_path__ + "static/media/TW_PromotionCard-print_Back.b399cbb1.jpg";